import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '@myenv/environment';

@Component({
    selector: 'app-reset-password-expired',
    templateUrl: './reset-password-expired.component.html',
    styleUrls: ['./reset-password-expired.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResetPasswordExpiredComponent implements OnInit {
  public footerText = environment.footerText;

  constructor(private title: Title) {
  }

  ngOnInit() {
    this.title.setTitle('Reset password' + environment.title_text);
  }
}
